module.exports = __webpack_public_path__ + "static/appstore-da74634ba3f7a4154f21e3d9f5199bb6.png";